import { 
  Container, 
  Stack, 
  Typography, 
  Button, 
  Card, 
  TableContainer, 
  Table, 
  Grid, 
  TableBody, 
  useMediaQuery, 
  TableRow, 
  TableCell, 
  IconButton, 
  TablePagination,
  Box,
  Chip,
  Avatar,
  Divider,
  Fade,
  Zoom,
  Tooltip,
  Paper
} from '@mui/material';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import Scrollbar from '../../../layouts/Scrollbar';
import { UserListHead, UserListToolbar, UserMoreMenu } from '../../../layouts/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import MiscSkeleton from '../../../layouts/user/MiscSkeleton';
import { GetAll, apiURL } from '../../../utils/apiCalls';
import { filter } from 'lodash';
import EditIcon from '@mui/icons-material/Edit';
import PeopleIcon from '@mui/icons-material/People';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import SearchNotFound from '../../../layouts/SearchNotFound';
import Iconify from '../../../layouts/Iconify';
import { dotCase, sentenceCase, capitalCase } from 'change-case';

import { AgGridReact } from "ag-grid-react";
import { fontSize } from '@mui/system';


// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'agent_id', label: 'Emp. Id', align: 'left' },
    { id: 'first_name', label: 'Name', align: 'left' },
    { id: 'email', label: 'Email', align: 'left' },
    { id: 'phone', label: 'Phone Number', align: 'left' },
    { id: '', label: '', align: 'center' },
  ];
  
  // ----------------------------------------------------------------------
  
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
  
  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
  
  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(array, (_user) => JSON.stringify(_user).toLowerCase().trim().indexOf(query.toLowerCase().trim()) !== -1);
    }
    return stabilizedThis.map((el) => el[0]);
  }

const AgentList = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [selected, setSelected] = useState([]);
    const [orderBy, setOrderBy] = useState();
    const [filterName, setFilterName] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
  
    async function GetList () {
      setLoading(true);
      // const response = await GetAll(apiURL + '/api/v1/users/agent');
      const response = await GetAll(apiURL + '/api/v1/users/get_agent_chain_asc');

           if(response) {
          if (response.data.status) {       
          setLoading(false);
          setList(response.data.data)
          }
          else {
          setLoading(false);
          toast.error(response.data.message)
            setList([])
          }
        }
        else {
          setLoading(false);
        }
  };
  
    useEffect(()=> {
      GetList();    
    },[])
  
    const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  
    const handleSelectAllClick = (event) => {
      if (event.target.checked) {
        const newSelecteds = list.map((n) => n.exporter_company_Name);
        setSelected(newSelecteds);
        return;
      }
      setSelected([]);
    };
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };
  
    const handleFilterByName = (event) => {
      setFilterName(event.target.value);
    };
  
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list.length) : 0;
  
    const filteredUsers = applySortFilter(list, getComparator(order, orderBy), filterName);
  
    const isUserNotFound = filteredUsers.length === 0;


  // const [rowData, setRowData] = useState([
  //   { id: 1, name: "John Doe", parentId: null },
  //   { id: 2, name: "Jane Doe", parentId: 1 },
  //   { id: 3, name: "Micheal Doe", parentId: 1 },
  //   { id: 4, name: "Eobard Thawne", parentId: null },
  //   { id: 5, name: "Bart Thawne", parentId: 4 },
  //   { id: 6, name: "Nora Thawne", parentId: 4 },
  //   { id: 7, name: "Barry Thawne", parentId: 4 },
  //   { id: 8, name: "Ragnarok", parentId: 2 },
  //   { id: 9, name: "SonicQ", parentId: null },
  //   { id: 10, name: "Zoom", parentId: 9 }
  // ]);

  const EditButton = (props) => {
    const handleClickEdit = (e) => {
      e.preventDefault();
  };
    return (
      <IconButton color="primary" onClick={(e) => handleClickEdit(e)}> <EditIcon /> </IconButton>
    )
  }

  // define columns and their respective fields
  const columnDefs = [ 
    // {
    //   field: "emp_id",
    //   filter: "agTextColumnFilter",
    //   headerName: "Employee ID",
    //   cellStyle: {fontSize: '16px'},
    //   filterParams: {
    //     filterOptions: ["contains", "notContains", "startsWith", "endsWith"],
    //     suppressAndOrCondition: true
    //   }
    // },
    {
      field: "first_name",
      filter: "agTextColumnFilter",
      headerName: "Name",
      minWidth: 190,
      cellStyle: {fontSize: '16px'},
      filterParams: {
        filterOptions: ["contains", "notContains", "startsWith", "endsWith"],
        suppressAndOrCondition: true
      }
    },
    {
      field: "role.designation",
      filter: "agTextColumnFilter",
      headerName: "Role",
      minWidth: 190,
      cellStyle: {fontSize: '16px'},
      filterParams: {
        filterOptions: ["contains", "notContains", "startsWith", "endsWith"],
        suppressAndOrCondition: true
      }
    },
    { field: "email", headerName: "Email",minWidth: 190,cellStyle: {fontSize: '16px'} },
    { field: "phone", headerName: "Phone Number",minWidth: 190,cellStyle: {fontSize: '16px'} },
    // { field: 'edit', minWidth: 190, cellRenderer: EditButton }
  ];

  // column properties
  const autoGroupColumnDef = {
    headerName: "Associate Code",
    minWidth: 200
  };

  // addded sort and filtering feature
  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true
  };

  //  handle tree
  const getDataPath = ({ id, ref_agent_id, emp_id }) => {
    const result = [emp_id];
    let row = filteredUsers.find((row) => row.id === ref_agent_id);
    while (row) {
      result.unshift(row.emp_id);
      row = filteredUsers.find((r) => r.id === row.ref_agent_id);
    }
    return result;
  };

  const gridRef = useRef();

  // handle search input
  const handleFilter = useCallback((event) => {
    setFilterName(event.target.value);
    // gridRef.current?.api.setQuickFilter(event.target.value);
  }, []);
  

    return (
        <Container sx={{m:0, width:'100%', maxWidth:'100%'}} maxWidth={false}>
        {/* Professional Header Section */}
        <Fade in timeout={800}>
          <Box sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={3} sx={{ mb: 3 }}>
              <Avatar sx={{ 
                bgcolor: '#1976d2', 
                width: 48, 
                height: 48,
                boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)'
              }}>
                <PeopleIcon sx={{ fontSize: 24, color: 'white' }} />
              </Avatar>
              <Box>
            <Typography variant="h5" component="h1" fontWeight="bold" color="text.primary">
              Associate Management
            </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Manage your associate network and hierarchy
                </Typography>
              </Box>
            </Stack>
            <Divider sx={{ my: 2 }} />
          </Box>
        </Fade>

       {/* <Card>
          <Stack spacing={2} justifyContent={'space-between'} direction={'row'} alignItems={'center'}>
          <UserListToolbar placeholder= "Search Agents..." numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
         <Button variant='contained' onClick={()=> navigate('/dashboard/agentUser/create')} sx={{height: 'max-content', marginRight: '24px'}} 
         startIcon={<Iconify icon="subway:add" />}>Create Agent</Button>
          </Stack>
         
            <TableContainer sx={{ minWidth: 800 }}>
              <Table stickyHeader >
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={list.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  isCheckbox={false}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    const { id, emp_id, first_name, last_name, email, phone } = row;
                    return (
                      <TableRow hover key={id}>
                        <TableCell component="th" scope="row" align="left">{emp_id}</TableCell>
                        <TableCell align="left">{`${capitalCase(first_name)} ${capitalCase(last_name)}`}</TableCell>
                        <TableCell align="left">{email}</TableCell>
                        <TableCell align="left">{phone}</TableCell>                      
                        <TableCell align="center">
                       <IconButton color="primary" onClick={(e) => handleClickEdit(e)}> <EditIcon /> </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody> {loading ? <MiscSkeleton record={{number: 7}}/> :
                    <TableRow>
                      <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                       {list.length <=0 ? <Typography gutterBottom align="center" variant="subtitle1"> Not found</Typography> :<SearchNotFound searchQuery={filterName} /> }
                      </TableCell>
                    </TableRow> }
                  </TableBody> 
                )}
              </Table>
            </TableContainer>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            component="div"
            count={filteredUsers.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card> */}

        <Zoom in timeout={1000}>
          <Card elevation={4} sx={{ 
            borderRadius: 3,
            overflow: 'hidden',
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
            height: '600px'
          }}>
            {/* Enhanced Toolbar Section */}
            <Box sx={{ 
              p: 3, 
              backgroundColor: '#f8f9fa',
              borderBottom: '1px solid #e9ecef'
            }}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6} lg={6} md={6} xl={6}>
                  <UserListToolbar 
                    placeholder="Search Associate..." 
                    numSelected={selected.length} 
                    filterName={filterName} 
                    onFilterName={handleFilter} 
                  />
                </Grid>
                <Grid item xs={12} sm={6} lg={6} md={6} xl={6} sx={{ 
                  justifyContent: isMobile ? 'center' : 'flex-end', 
                  alignItems: 'center', 
                  display: 'flex' 
                }}>
                  <Button 
                    variant='contained' 
                    onClick={() => navigate('/dashboard/agentUser/create')} 
                    sx={{ 
                      height: 'max-content', 
                      marginRight: '24px !important', 
                      marginBottom: '15px !important', 
                      width: isMobile ? '80%' : 'max-content',
                      backgroundColor: '#1976d2',
                      '&:hover': {
                        backgroundColor: '#1565c0'
                      },
                      borderRadius: 2,
                      px: 3,
                      py: 1.5,
                      fontWeight: 'bold'
                    }}
                    startIcon={<PersonAddIcon />}
                  >
                    Create Associate
                  </Button>
                </Grid>
              </Grid>
            </Box>

            {/* AG Grid Container */}
            <Box sx={{ p: 2, height: '500px' }}>
              <div className="ag-theme-alpine" style={{ height: "100%", width: "100%" }}>

                {/* ag-grid component */}
                <AgGridReact
                  rowData={filteredUsers}
                  treeData={true}
                  animateRows={true}
                  autoGroupColumnDef={autoGroupColumnDef}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  getDataPath={getDataPath}
                  ref={gridRef}
                  pagination={true}
                  paginationPageSize={10}
                  style={{fontSize:'16px'}}
                  frameworkComponents={{
                    EditButton,
                  }}
                />
              </div>
            </Box>
          </Card>
        </Zoom>

        {/* Professional Stats Footer */}
        <Fade in timeout={1200}>
          <Box sx={{ mt: 4 }}>
            <Paper elevation={2} sx={{ 
              p: 3, 
              borderRadius: 3,
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef'
            }}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ 
                      bgcolor: '#1976d2', 
                      width: 40, 
                      height: 40 
                    }}>
                      <PeopleIcon sx={{ fontSize: 20 }} />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold" color="text.primary">
                        {list.length}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Total Associates
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ 
                      bgcolor: '#28a745', 
                      width: 40, 
                      height: 40 
                    }}>
                      <BusinessIcon sx={{ fontSize: 20 }} />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold" color="text.primary">
                        {new Set(list.map(item => item.role?.designation).filter(Boolean)).size}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Different Roles
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ 
                      bgcolor: '#ffc107', 
                      width: 40, 
                      height: 40 
                    }}>
                      <EmailIcon sx={{ fontSize: 20 }} />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold" color="text.primary">
                        {list.filter(item => item.email).length}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Active Emails
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </Fade>
      </Container>
    )
}

export default AgentList;